import React, { useState, useEffect } from 'react'
import { GetSites } from '../../services/sites/sites'
import CustomSelect from './CustomSelect'
import { error, success } from '../../constants/msg'
import { FIELD } from '../../constants/app-constants'
import { post_type_options, recent_events_options, slider_tolerance_options } from '../../utils/constants'
import { GetDepartmentsBySite } from '../../services/departments/departments'

const CustomSliderToleranceSelect = (props) => {
    const [options, setOptions] = useState(slider_tolerance_options)

    return (
        <CustomSelect
            {...props}
            placeholder={props.placeholder}
            isDisabled={false}
            isLoading={false}
            isClearable={props.isClearable}
            options={options}
        />
    )
}

export default CustomSliderToleranceSelect